import ToastsConnected from './ToastsConnected'

export default ToastsConnected
